<editable-form [form]="form!" [disabled]="formDisabled" [title]="isModal ? '' : title" [confirmLabel]="confirmLabel"
  (submit)="onSaveData()" (cancel)="onCancel()">
  <div class="row">
    <div class="row">
      <span><strong class="me-3">{{ 'Entidade:' }}</strong>{{ auth.entidade?.nome || '' }}</span>
      <span><strong class="me-3">{{ 'Usuário:' }}</strong>{{ auth.usuario?.nome || '' }}</span>
      <!-- <span><strong class="me-3">{{ 'Execução:' }}</strong>{{ getFormattedDataExecucao() }}</span> -->
      <span><strong class="me-3">{{ 'Tipo de Integração:' }}</strong>{{ tipo_integracao == 'API_SIAPE' ? 'Integração com o Siape - ' + (auth.entidade?._metadata?.integracao_siape_tipo || '') : 'Envio de Dados do PGD para a API do Órgão Central'}}</span>
      <span *ngIf="dataHoraExecucao.length"><strong class="me-3">{{ 'Tempo decorrido:' }}</strong>{{ duracao() }}</span>
    </div>
    <div *ngIf="formDisabled && entity?.tipo == 'API_SIAPE'" class="row">
      <separator title="UNIDADES" [collapse]="'collapse'" class="mt-2">
        <div class="row">
          <span><strong>Resultado</strong></span>
          <span>{{ resultado_unidades }}</span>
        </div>
        <div class="row mt-2">
          <span><strong>Observações</strong></span>
          <span *ngFor="let obs of obs_unidades; index as i">{{ '[' + (i+1) + '] ' + obs }}</span>
        </div>
        <div *ngIf="falhas_unidades.length > 0" class="row mt-2">
          <span><strong>Falhas</strong></span>
          <span *ngFor="let falha of falhas_unidades; index as i">{{ '[' + (i+1) + '] ' + falha }}</span>
        </div>
      </separator>
      <separator title="SERVIDORES" [collapse]="'collapse'">
        <div class="row">
          <span><strong>Resultado</strong></span>
          <span>{{ resultado_servidores }}</span>
        </div>
        <div class="row mt-2">
          <span><strong>Observações</strong></span>
          <span *ngFor="let obs of obs_servidores; index as i">{{ '[' + (i+1) + '] ' + obs }}</span>
        </div>
        <div *ngIf="falhas_servidores.length > 0" class="row mt-2">
          <span><strong>Falhas</strong></span>
          <span *ngFor="let falha of falhas_servidores; index as i">{{ '[' + (i+1) + '] ' + falha }}</span>
        </div>
      </separator>
      <separator title="CHEFIAS" [collapse]="'collapse'">
        <div class="row">
          <span><strong>Resultado</strong></span>
          <span>{{ resultado_gestores }}</span>
        </div>
        <div class="row mt-2">
          <span><strong>Observações</strong></span>
          <span *ngFor="let obs of obs_gestores; index as i">{{ '[' + (i+1) + '] ' + obs }}</span>
        </div>
        <div *ngIf="falhas_gestores.length > 0" class="row mt-2">
          <span><strong>Falhas</strong></span>
          <span *ngFor="let falha of falhas_gestores; index as i">{{ '[' + (i+1) + '] ' + falha }}</span>
        </div>
      </separator>
      <separator title="AFASTAMENTOS" [collapse]="'collapse'">
        <div class="row">
          <span><strong>Resultado</strong></span>
          <span>{{ resultado_afastamentos }}</span>
        </div>
        <div class="row mt-2">
          <span><strong>Observações</strong></span>
          <span *ngFor="let obs of obs_afastamentos; index as i">{{ '[' + (i+1) + '] ' + obs }}</span>
        </div>
        <div *ngIf="falhas_afastamentos.length > 0" class="row mt-2">
          <span><strong>Falhas</strong></span>
          <span *ngFor="let falha of falhas_afastamentos; index as i">{{ '[' + (i+1) + '] ' + falha }}</span>
        </div>
      </separator>
    </div>
    <div *ngIf="formDisabled && entity?.tipo == 'API_DADOS_ORGAO_CENTRAL'" class="row">
      <separator title="PARTICIPANTES" [collapse]="'collapse'" class="mt-2">
        <div class="row">
          <span><strong>Resultado</strong></span>
          <span>{{ resultado_participantes }}</span>
        </div>
        <div *ngIf="obs_participantes.length > 0" class="row mt-2">
          <span><strong>Observações</strong></span>
          <span *ngFor="let obs of obs_participantes; index as i">{{ '[' + (i+1) + '] ' + obs }}</span>
        </div>
        <div *ngIf="falhas_participantes?.length > 0" class="row mt-2">
          <span><strong>Falhas</strong></span>
          <span *ngFor="let f of falhas_participantes; index as i">{{ '[' + (i+1) + '] ID do Participante: ' + f['ID do participante'] + ' Falha: ' + f.falha }}</span>
        </div>
      </separator>
      <separator title="PLANOS DE ENTREGAS" [collapse]="'collapse'" class="mt-2">
        <div class="row">
          <span><strong>Resultado</strong></span>
          <span>{{ resultado_planos_entregas }}</span>
        </div>
        <div *ngIf="obs_planos_entregas.length > 0" class="row mt-2">
          <span><strong>Observações</strong></span>
          <span *ngFor="let obs of obs_planos_entregas; index as i">{{ '[' + (i+1) + '] ' + obs }}</span>
        </div>
        <div *ngIf="falhas_planos_entregas?.length > 0" class="row mt-2">
          <span><strong>Falhas</strong></span>
          <span *ngFor="let f of falhas_planos_entregas; index as i">{{ '[' + (i+1) + '] ID do Plano de Entregas: ' + f['ID do plano de entregas'] + ' Falha: ' + f.falha }}</span>
        </div>
      </separator>
      <separator title="PLANOS DE TRABALHO" [collapse]="'collapse'" class="mt-2">
        <div class="row">
          <span><strong>Resultado</strong></span>
          <span>{{ resultado_planos_trabalho }}</span>
        </div>
        <div *ngIf="obs_planos_trabalho.length > 0" class="row mt-2">
          <span><strong>Observações</strong></span>
          <span *ngFor="let obs of obs_planos_trabalho; index as i">{{ '[' + (i+1) + '] ' + obs }}</span>
        </div>
        <div *ngIf="falhas_planos_trabalho?.length > 0" class="row mt-2">
          <span><strong>Falhas</strong></span>
          <span *ngFor="let f of falhas_planos_trabalho; index as i">{{ '[' + (i+1) + '] ID do Plano de Trabalho: ' + f['ID do plano de trabalho'] + ' Falha: ' + f.falha }}</span>
        </div>
      </separator>
      <separator *ngIf="falhas_contribuicoes?.length > 0" [title]="'FALHAS EM CONTRIBUIÇÕES (' + falhas_contribuicoes.length + ')'" [collapse]="'collapse'" class="mt-2">
        <div class="row mt-2">
          <span><strong>Falhas</strong></span>
          <span *ngFor="let f of falhas_contribuicoes; index as i">{{ '[' + (i+1) + '] ID do Plano de Trabalho: ' + f['ID do plano de trabalho'] + ' ID da Contribuição: ' + f['ID da contribuição'] + ' Falha: ' + f.falha }}</span>
        </div>
      </separator>
      <separator *ngIf="falhas_avaliacoes?.length > 0" [title]="'FALHAS EM AVALIAÇÕES (' + falhas_avaliacoes.length + ')'" [collapse]="'collapse'" class="mt-2">
        <div class="row mt-2">
          <span><strong>Falhas</strong></span>
          <span *ngFor="let f of falhas_avaliacoes; index as i">{{ '[' + (i+1) + '] ID do Plano de Trabalho: ' + f['ID do plano de trabalho'] + ' ID da Avaliação: ' + f['ID da avaliação'] + ' Falha: ' + f.falha }}</span>
        </div>
      </separator>
      <separator *ngIf="falhas_entregas?.length > 0" [title]="'FALHAS NAS ENTREGAS DOS PLANOS DE ENTREGAS (' + falhas_entregas.length + ')'" [collapse]="'collapse'" class="mt-2">
        <div class="row mt-2">
          <span><strong>Falhas</strong></span>
          <span *ngFor="let f of falhas_entregas; index as i">{{ '[' + (i+1) + '] ID do Plano de Entregas: ' + f['ID do plano de entregas'] + ' ID da Entrega: ' + f['ID da entrega'] + ' Falha: ' + f.falha }}</span>
        </div>
      </separator>
      <separator *ngIf="falhas_programas_participantes?.length > 0" [title]="'FALHAS NAS PARTICIPAÇÕES NO PROGRAMA (' + falhas_programas_participantes.length + ')'" [collapse]="'collapse'" class="mt-2">
        <div class="row mt-2">
          <span><strong>Falhas</strong></span>
          <span *ngFor="let f of falhas_programas_participantes; index as i">{{ '[' + (i+1) + '] ID do ProgramaParticipante: ' + f['ID do programaParticipante'] + ' Falha: ' + f.falha }}</span>
        </div>
      </separator>
    </div>
    <separator *ngIf="tipo_integracao == 'API_SIAPE'" [title]="formDisabled ? 'Parâmetros utilizados' : ''" [collapse]="formDisabled ? 'collapse' : undefined" class="mt-2">
      <div class="row">
        <separator title="Deve ser atualizado:">
          <input-switch [disabled]="formDisabled ? 'true' : undefined" labelPosition="right" [size]="4" label="Unidades" controlName="atualizar_unidades" [control]="form!.controls.atualizar_unidades"></input-switch>
          <input-switch [disabled]="formDisabled ? 'true' : undefined" labelPosition="right" [size]="4" label="Servidores" controlName="atualizar_servidores" [control]="form!.controls.atualizar_servidores"></input-switch>
          <input-switch [disabled]="formDisabled ? 'true' : (!this.util.isDeveloper() ? 'true' : undefined)" labelPosition="right" [size]="4" label="Chefias" labelInfo="É necessário atualizar unidades e servidores para atualizar as chefias." controlName="atualizar_gestores" [control]="form!.controls.atualizar_gestores"></input-switch>
          <input-switch [disabled]="formDisabled ? 'true' : undefined" labelPosition="right" [size]="4" label="Afastamentos" labelInfo="Somente busca afastamentos (férias incluso) dos servidores com plano de trabalho ativo." controlName="atualizar_afastamentos" [control]="form!.controls.atualizar_afastamentos"></input-switch>
        </separator>
      </div>
      <div class="row mt-4" *ngIf="!production">
        <separator title="Com relação aos dados atualizados">
          <input-switch [disabled]="formDisabled ? 'true' : undefined" labelPosition="right" [size]="4" label="Usar arquivos locais" controlName="usar_arquivos_locais" [control]="form!.controls.usar_arquivos_locais" labelInfo="Selecione se os dados para atualização devem ser lidos de um arquivo local."></input-switch>
          <input-switch [disabled]="formDisabled ? 'true' : undefined" labelPosition="right" [size]="4" label="Gravar em arquivos locais" controlName="gravar_arquivos_locais" [control]="form!.controls.gravar_arquivos_locais" labelInfo="Selecione se os dados atualizados devem ser salvos em um arquivo local."></input-switch>
        </separator>
      </div>
    </separator>
  </div>
</editable-form>